<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showOption"
        class="fixed inset-0 z-50 bg-black bg-opacity-70 h-screen w-full"
      >
        <div
          class="fixed w-full max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 overflow-y-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="absolute inset-0 bg-black bg-opacity-10 rounded-md w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-primary text-white p-3 rounded-t-md"
          >
            <p class="text-base">{{ title }}</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg"
              src="@/assets/icons/cross-white.png"
              alt="Close"
              @click="handleClose()"
            />
          </div>
          <section
            class="p-5"
            v-if="!title.toLowerCase().includes('carry forward')"
          >
            <label for="">Period Name</label>
            <el-select
              v-model="selectedPeriod"
              :placeholder="'Select period to ' + title"
              class="w-full"
            >
              <el-option
                v-for="period in periods"
                :label="period.PeriodName"
                :value="period"
                :key="period.Id"
                >{{ period.PeriodName }}</el-option
              >
            </el-select>
          </section>
          <!-- START OF CARRY FORWARD -->
          <section
            v-if="title.toLowerCase().includes('carry forward')"
            class="p-5"
          >
            <label for="">Select Period Range</label>
            <div class="flex">
              <el-select
                v-model="selectedFromYear"
                placeholder="From Year"
                class="w-full mr-2"
                :value-key="'Id'"
              >
                <!-- Add options for 'From' year -->
                <el-option
                  v-for="period in periods"
                  :label="period.PeriodName"
                  :value="period"
                  :key="period.Id"
                  >{{ period.PeriodName }}</el-option
                >
              </el-select>
              <el-select
                v-model="selectedToYear"
                placeholder="To Year"
                class="w-full"
                :disabled="!selectedFromYear"
                :value-key="'Id'"
              >
                <!-- Add options for 'To' year based on the selected 'From' year -->
                <el-option
                  v-for="period in filteredToYears"
                  :label="period.PeriodName"
                  :value="period"
                  :key="period.Id"
                  >{{ period.PeriodName }}</el-option
                >
              </el-select>
            </div>
          </section>
          <!-- END OF CARRY FORWARD -->

          <!-- Export button -->
          <div class="flex justify-end p-5 gap-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2 w-28"
              @click="confirmAction()"
            >
              OK
            </button>
            <button
              type=""
              class="bg-primary rounded-full px-10 text-sm text-white py-2 w-28"
              @click="handleClose()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import { MessageBox } from "element-ui";
import { mapGetters } from "vuex";

export default {
  name: "PeriodCloseOptions",
  props: ["showOption", "title", "close", "selectPeriodCallback"],
  components: { Loader },
  data() {
    return {
      loading: false,
      periods: [],
      selectedPeriod: null,
      selectedFromYear: null,
      selectedToYear: null,
    };
  },
  created() {
    this.getPeriods();
  },
  watch: {},
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredToYears() {
      // Filter the periods array to exclude the selected 'From Year' and earlier years
      return this.periods.filter(
        (period) => period.PeriodName > this.selectedFromYear?.PeriodName
      );
    },
  },
  methods: {
    confirmAction() {
      const period = this.selectedPeriod;
      const actionText = this.title.toLowerCase();
      MessageBox.confirm(
        `This action is irreversible. Are you sure you want to ${actionText} ${
          period
            ? period.PeriodName
            : `${this.selectedFromYear.PeriodName} to ${this.selectedToYear.PeriodName}`
        }?`,
        "Confirmation",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          customClass: {
            confirmButton: "bg-primary rounded-full px-10 text-sm text-white",
            cancelButton:
              "bg-gray-300 rounded-full px-10 text-sm text-gray-700",
            message: "text-base",
          },
        }
      )
        .then(() => {
          if (this.title.toLowerCase().includes("carry forward")) {
            this.selectPeriodCallback(
              this.selectedFromYear,
              this.selectedToYear
            );
          } else {
            this.selectPeriodCallback(period);
          }
        })
        .catch(() => {});
    },
    handleClose() {
      this.close();
    },
    proceed() {
      if (!this.selectedPeriod) {
        this.$notify.error({
          title: "Invalid Action",
          message:
            "You have not selected any period. Select a period to continue.",
        });
        return;
      } else {
        this.selectPeriodCallback(this.selectedPeriod);
      }
      this.close();
    },

    handleCheckAllChange(val) {
      this.selectedLeaveNames = val ? [...this.leaveNames] : [];
      this.isIndeterminate = false;
    },
    handleCheckedLeaveChange(value) {
      let checkedCount = value.length;
      this.exportAll = checkedCount === this.leaveNames.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.leaveNames.length;
    },

    getPeriods() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leave/period/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.periods = response.data.Data;
              this.latestDate = response.data.Data[0];
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped></style>
